__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/637b336/_next/";